import styled from "styled-components";

const Footer = styled.footer`
  grid-area: footer;
  z-index: 2;
  background-color: #2e2a27;
  box-shadow: 0 -5px 5px #000000;
  padding-top: 2%;
  padding-bottom: 2%;
  text-align: center;
`;

export default Footer;
